import I18n from "i18n-js";
import { makeAutoObservable } from "mobx";
import { RDate } from "../../core";
import { OnTimeFulfillmentTime, } from "../../ordering";
import { RArray } from "../../collections";
export class PInFutureFulfillmentTime {
    constructor(params) {
        this.type = "InFuture";
        this.purchaseOrderFulfillmentTime = params.purchaseOrderFulfillmentTime;
        this.label = I18n.t("orders.form.choose_date");
        this.timezone = params.timezone;
        makeAutoObservable(this);
    }
    get fulfillmentTime() {
        return this.purchaseOrderFulfillmentTime.fulfillmentTime;
    }
    get activeDate() {
        return this.purchaseOrderFulfillmentTime.activeDate;
    }
    get isAvailable() {
        return this.purchaseOrderFulfillmentTime.inFutureOptionAvailabile;
    }
    get isActive() {
        return (this.isAvailable &&
            this.fulfillmentTime !== null &&
            this.fulfillmentTime.type === "OnTime");
    }
    get dates() {
        return this.purchaseOrderFulfillmentTime.availableDates;
    }
    get hours() {
        var _a;
        return (((_a = this.activeDate) === null || _a === void 0 ? void 0 : _a.hours.map((item) => item.fullHour)) || RArray.empty());
    }
    get dateOptions() {
        // NOTICE: Options are currently limitted to 31 elements to not display very large list of options in the select field.
        // We are planning to change the way of selecting date and hour in the future so it will be removed.
        return this.dates.take(31).raw.map(({ date }) => ({
            label: `${getDayName(date)}, ${date.format("DD.MM")}`,
            value: date.fullDate,
        }));
    }
    get timeOptions() {
        return this.hours.raw.map((hour) => ({
            label: hour,
            value: hour,
        }));
    }
    get dateDisabled() {
        return this.dates.isEmpty;
    }
    get timeDisabled() {
        return this.hours.isEmpty;
    }
    setDefaultValue() {
        if (this.dates.isEmpty) {
            return;
        }
        this.purchaseOrderFulfillmentTime.fulfillmentTime =
            new OnTimeFulfillmentTime({
                date: this.dates.get(0).hours.get(0),
                label: null,
            });
    }
    setDate(value) {
        const date = RDate.fromString(value, this.timezone);
        if (!date.isValid) {
            return; // TODO: what if date is not valid?
        }
        const dateWithHours = this.purchaseOrderFulfillmentTime.getDate(date);
        this.purchaseOrderFulfillmentTime.fulfillmentTime =
            new OnTimeFulfillmentTime({
                date: dateWithHours !== null ? dateWithHours.hours.get(0) : date,
                label: null,
            });
    }
    setHour(value) {
        if (this.activeDate === null) {
            return;
        }
        const hour = this.activeDate.hours.findWhere((item) => item.fullHour === value);
        if (hour === null) {
            return;
        }
        this.purchaseOrderFulfillmentTime.fulfillmentTime =
            new OnTimeFulfillmentTime({
                date: hour,
                label: null,
            });
    }
}
function getDayName(date) {
    const translated = date.isToday
        ? I18n.t("date.today")
        : date.isTomorrow
            ? I18n.t("date.tomorrow")
            : I18n.t(`date.day.names.${date.weekday.toLowerCase()}`);
    // NOTICE: Capitalize first letter due to translations missmatch (monday, Friday, etc.)
    return translated.charAt(0).toUpperCase() + translated.slice(1);
}
